export const DEFAULT_TITLE = 'Something went wrong';
export const DEFAULT_TEXT = `Oops, it appears there's an issue. Please reload the page.`;
